// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_interaction.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetHostAuthenticationTokenValueRequest, GetHostAuthenticationTokenValueResponse, GetLatestVersionRequest, GetLatestVersionResponse, GetManagedRunnerRequest, GetManagedRunnerResponse, GetRunnerAgentExecutionRequest, GetRunnerAgentExecutionResponse, GetRunnerConfigurationRequest, GetRunnerConfigurationResponse, GetRunnerEnvironmentRequest, GetRunnerEnvironmentResponse, GetRunnerLLMIntegrationRequest, GetRunnerLLMIntegrationResponse, ListManagedRunnersRequest, ListManagedRunnersResponse, ListRunnerAgentExecutionsRequest, ListRunnerAgentExecutionsResponse, ListRunnerEnvironmentClassesRequest, ListRunnerEnvironmentClassesResponse, ListRunnerEnvironmentsRequest, ListRunnerEnvironmentsResponse, ListRunnerLLMIntegrationsRequest, ListRunnerLLMIntegrationsResponse, ListRunnerSCMIntegrationsRequest, ListRunnerSCMIntegrationsResponse, MarkRunnerActiveRequest, MarkRunnerActiveResponse, SendResponseRequest, SendResponseResponse, SignupRequest, SignupResponse, UpdateRunnerAgentExecutionRequest, UpdateRunnerAgentExecutionResponse, UpdateRunnerConfigurationSchemaRequest, UpdateRunnerConfigurationSchemaResponse, UpdateRunnerEnvironmentStatusRequest, UpdateRunnerEnvironmentStatusResponse, UpdateRunnerStatusRequest, UpdateRunnerStatusResponse, WatchRequestsRequest, WatchRequestsResponse } from "./runner_interaction_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * RunnerInteractionService provides a way for the backend to interact with environment runners.
 *
 * @generated from service gitpod.v1.RunnerInteractionService
 */
export const RunnerInteractionService = {
  typeName: "gitpod.v1.RunnerInteractionService",
  methods: {
    /**
     * Establishes initial connection between a runner and the Gitpod backend. This is the first
     * call a runner makes to register itself and establish its identity.
     *
     * Use this method to:
     * - Register new runners with the platform
     * - Exchange cryptographic keys for secure communication
     * - Declare supported environment classes and capabilities
     * - Initialize runner configuration
     *
     * ### Examples
     *
     * - Register runner:
     *
     *   Registers a new runner with its public key and supported environment classes.
     *
     *   ```yaml
     *   publicKey: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"  # 32 bytes of zeros, base64 encoded
     *   environmentClasses:
     *     - id: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *       runnerId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *       displayName: "Large Instance"
     *       description: "8 CPU, 16GB RAM"
     *       enabled: true
     *       configuration:
     *         - key: "cpu"
     *           value: "8"
     *         - key: "memory"
     *           value: "16384"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.Signup
     */
    signup: {
      name: "Signup",
      I: SignupRequest,
      O: SignupResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Maintains the active status of a runner through periodic heartbeat signals. The runner must
     * call this method every 30 seconds to indicate it's healthy and ready to accept workloads.
     *
     * Use this method to:
     * - Keep runners marked as available in the system
     * - Maintain health check status
     * - Prevent automatic deregistration
     * - Signal readiness for new workloads
     *
     * ### Examples
     *
     * - Send heartbeat:
     *
     *   Marks a runner as active and healthy.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.MarkRunnerActive
     */
    markRunnerActive: {
      name: "MarkRunnerActive",
      I: MarkRunnerActiveRequest,
      O: MarkRunnerActiveResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves environment details for a specific runner.
     *
     * Use this method to:
     * - Get environment configuration
     * - Check environment status
     * - Verify environment ownership
     *
     * ### Examples
     *
     * - Get environment:
     *
     *   Retrieves environment details.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerEnvironment
     */
    getRunnerEnvironment: {
      name: "GetRunnerEnvironment",
      I: GetRunnerEnvironmentRequest,
      O: GetRunnerEnvironmentResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists all environments managed by a runner.
     *
     * Use this method to:
     * - View assigned environments
     * - Monitor environment status
     * - Check environment assignments
     *
     * ### Examples
     *
     * - List environments:
     *
     *   Shows all environments for a runner.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - List specific environments:
     *
     *   Shows details for specific environment IDs.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   environmentIds: ["07e03a28-65a5-4d98-b532-8ea67b188048"]
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerEnvironments
     */
    listRunnerEnvironments: {
      name: "ListRunnerEnvironments",
      I: ListRunnerEnvironmentsRequest,
      O: ListRunnerEnvironmentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Provides comprehensive status updates about a managed environment. This method allows
     * runners to report detailed state information about environments they're managing.
     *
     * Use this method to:
     * - Report current environment phase and health status
     * - Update machine and container states
     * - Signal content and devcontainer readiness
     * - Provide access URLs and endpoints
     * - Report warnings or failure conditions
     *
     * ### Examples
     *
     * - Update status:
     *
     *   Provides a detailed status update for an environment.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   environmentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   status:
     *     phase: ENVIRONMENT_PHASE_RUNNING
     *     statusVersion: "1"
     *     failureMessage: []
     *     warningMessage: []
     *     machine:
     *       phase: PHASE_RUNNING
     *     content:
     *       phase: CONTENT_PHASE_READY
     *     devcontainer:
     *       phase: PHASE_RUNNING
     *     environmentUrls:
     *       logs: "https://logs.gitpod.io/environment"
     *       ports: []
     *       ssh:
     *         url: "ssh://ssh.gitpod.io:22"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerEnvironmentStatus
     */
    updateRunnerEnvironmentStatus: {
      name: "UpdateRunnerEnvironmentStatus",
      I: UpdateRunnerEnvironmentStatusRequest,
      O: UpdateRunnerEnvironmentStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the runner's status and capabilities.
     *
     * Use this method to:
     * - Report runner health
     * - Update version information
     * - Signal system changes
     * - Configure capabilities
     *
     * ### Examples
     *
     * - Update status:
     *
     *   Updates runner status and details.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   version: "1.2.3"
     *   systemDetails: "Linux x86_64"
     *   logUrl: "https://logs.example.com/runner"
     *   region: "us-west"
     *   capabilities: ["RUNNER_CAPABILITY_SECRET_CONTAINER_REGISTRY"]
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerStatus
     */
    updateRunnerStatus: {
      name: "UpdateRunnerStatus",
      I: UpdateRunnerStatusRequest,
      O: UpdateRunnerStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the configuration schema for a runner.
     *
     * Use this method to:
     * - Define configuration options
     * - Update schema definitions
     * - Set validation rules
     *
     * ### Examples
     *
     * - Update schema:
     *
     *   Updates runner configuration schema.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   configSchema:
     *     version: "1.0"
     *     runnerConfig:
     *       - id: "region"
     *         name: "Region"
     *         description: "Deployment region"
     *         required: true
     *         string:
     *           default: "us-west"
     *           pattern: "^[a-z]+-[a-z]+-[0-9]+$"
     *       - id: "autoUpdate"
     *         name: "Auto Update"
     *         description: "Enable automatic updates"
     *         required: true
     *         bool:
     *           default: true
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerConfigurationSchema
     */
    updateRunnerConfigurationSchema: {
      name: "UpdateRunnerConfigurationSchema",
      I: UpdateRunnerConfigurationSchemaRequest,
      O: UpdateRunnerConfigurationSchemaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieves authentication token for accessing remote hosts.
     *
     * Use this method to:
     * - Get host credentials
     * - Access SCM tokens
     * - Verify authentication
     *
     * ### Examples
     *
     * - Get token:
     *
     *   Retrieves authentication token for a host.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   principalId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   host: "github.com"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.GetHostAuthenticationTokenValue
     */
    getHostAuthenticationTokenValue: {
      name: "GetHostAuthenticationTokenValue",
      I: GetHostAuthenticationTokenValueRequest,
      O: GetHostAuthenticationTokenValueResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists environment classes configured for a runner.
     *
     * Use this method to:
     * - View available classes
     * - Check class configurations
     * - Monitor class status
     *
     * ### Examples
     *
     * - List classes:
     *
     *   Shows environment classes for a runner.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerEnvironmentClasses
     */
    listRunnerEnvironmentClasses: {
      name: "ListRunnerEnvironmentClasses",
      I: ListRunnerEnvironmentClassesRequest,
      O: ListRunnerEnvironmentClassesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists SCM integrations configured for a runner.
     *
     * Use this method to:
     * - View SCM configurations
     * - Check integration status
     * - Monitor available SCMs
     *
     * ### Examples
     *
     * - List integrations:
     *
     *   Shows SCM integrations for a runner.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerSCMIntegrations
     */
    listRunnerSCMIntegrations: {
      name: "ListRunnerSCMIntegrations",
      I: ListRunnerSCMIntegrationsRequest,
      O: ListRunnerSCMIntegrationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Streams requests that need to be handled by the runner.
     *
     * Use this method to:
     * - Receive configuration changes
     * - Handle environment updates
     * - Process integration events
     * - Monitor real-time events
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.WatchRequests
     */
    watchRequests: {
      name: "WatchRequests",
      I: WatchRequestsRequest,
      O: WatchRequestsResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Sends a response to a previously received request.
     *
     * Use this method to:
     * - Respond to requests
     * - Report operation results
     * - Handle errors
     *
     * ### Examples
     *
     * - Send response:
     *
     *   Responds to a request.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   requestId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   callParseContext:
     *     resp:
     *       originalContextUrl: "https://github.com/org/repo"
     *       git:
     *         host: "github.com"
     *         owner: "org"
     *         repo: "repo"
     *         branch: "main"
     *         cloneUrl: "https://github.com/org/repo.git"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.SendResponse
     */
    sendResponse: {
      name: "SendResponse",
      I: SendResponseRequest,
      O: SendResponseResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the latest version information for a runner.
     *
     * Use this method to:
     * - Check for updates
     * - Get version details
     * - Verify compatibility
     *
     * ### Examples
     *
     * - Get version:
     *
     *   Retrieves latest version info.
     *
     *   ```yaml
     *   runnerId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   currentVersion: "1.2.3"
     *   infrastructureVersion: "4.5.6"
     *   ```
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.GetLatestVersion
     */
    getLatestVersion: {
      name: "GetLatestVersion",
      I: GetLatestVersionRequest,
      O: GetLatestVersionResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerConfiguration
     */
    getRunnerConfiguration: {
      name: "GetRunnerConfiguration",
      I: GetRunnerConfigurationRequest,
      O: GetRunnerConfigurationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerAgentExecutions
     */
    listRunnerAgentExecutions: {
      name: "ListRunnerAgentExecutions",
      I: ListRunnerAgentExecutionsRequest,
      O: ListRunnerAgentExecutionsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerAgentExecution
     */
    getRunnerAgentExecution: {
      name: "GetRunnerAgentExecution",
      I: GetRunnerAgentExecutionRequest,
      O: GetRunnerAgentExecutionResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerInteractionService.UpdateRunnerAgentExecution
     */
    updateRunnerAgentExecution: {
      name: "UpdateRunnerAgentExecution",
      I: UpdateRunnerAgentExecutionRequest,
      O: UpdateRunnerAgentExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerInteractionService.GetRunnerLLMIntegration
     */
    getRunnerLLMIntegration: {
      name: "GetRunnerLLMIntegration",
      I: GetRunnerLLMIntegrationRequest,
      O: GetRunnerLLMIntegrationResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerInteractionService.ListRunnerLLMIntegrations
     */
    listRunnerLLMIntegrations: {
      name: "ListRunnerLLMIntegrations",
      I: ListRunnerLLMIntegrationsRequest,
      O: ListRunnerLLMIntegrationsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists all runners managed by this runner manager.
     *
     * @generated from rpc gitpod.v1.RunnerInteractionService.ListManagedRunners
     */
    listManagedRunners: {
      name: "ListManagedRunners",
      I: ListManagedRunnersRequest,
      O: ListManagedRunnersResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc gitpod.v1.RunnerInteractionService.GetManagedRunner
     */
    getManagedRunner: {
      name: "GetManagedRunner",
      I: GetManagedRunnerRequest,
      O: GetManagedRunnerResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

